import { Modal, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import type { TComponent } from 'utils/types/component';

import { CreateSettingsForm } from './components/CreateSettingsForm';
import { EditSettingsTable } from './components/EditSettingsTable';

interface IInvoicesExportSettingsModalProps {
    onClose: () => void;
}

export const InvoicesExportSettingsModal: TComponent<
    IInvoicesExportSettingsModalProps
> = (props) => {
    const { onClose } = props;

    const { t } = useTranslation();

    const tabs = [
        {
            key: '1',
            label: t('invoices.payout.exportSettings.create'),
            children: <CreateSettingsForm onClose={onClose} />,
        },
        {
            key: '2',
            label: t('invoices.payout.exportSettings.edit'),
            children: <EditSettingsTable />,
        },
    ];

    return (
        <Modal
            open
            onCancel={onClose}
            footer={null}
            title={t('invoices.payout.exportSettings.title')}
            width={1100}
        >
            <Tabs items={tabs} />
        </Modal>
    );
};
